<template lang="pug">
  .card(@click="clickKit(kit)")
    .image-wrap
      img(:src="kit.image.url")
      img.overlay(v-if="kit.imageOverlay?.url" :src="kit.imageOverlay.url")
    .texts.mt-50m
      .name.bold.brand-color-5.xs-f-xsmall.md-f-small.max-at-tweak
        span(v-html="kitName(kit.title, kit.titleAccent, kit.accentColor)") 
      .cta
        a.mr-btn.btn-secondary.btn-round.xs-f-xxsmall.max-at-tweak(:href="kit.link.url" @click.prevent="clickKit(kit)") {{ kit.link.text }}
          .icon-arrow-forward
</template>
<script>
  export default {
    name: "KitCard",

    props: {
      kit: {
        type: Object,
        default: () => ({})
      }
    },

    methods: {
      kitName(text1, text2, color) {
        let name = `${text1}`;
        if (text2) {
          name += ` <span style="color:${color}">${text2}</span>`;
        }
        return name;
      },

      kitNameForEvent() {
        return this.kit.shadeName;
      },

      clickKit(kit) {
        this.trackMREventAndRedirect(`Color wonder shade carousel - ${this.kitNameForEvent()} shade clicked`, kit.link.url);
      },

    }

  };
</script>
<style lang="stylus" scoped>
  .card
    width 382px
    padding 0 1em 0 0
    cursor pointer
    letter-spacing -0.02em

    .image-wrap
      position relative
      width 100%
      img
        height 100%
        width 100%
        object-fit cover
      .overlay-wrap
        position absolute
        width 100%
        height 100%
        left 0
        top 0
      img.overlay
        position absolute
        top 28%
        right 7px
        height 70%
        width 40%
        transition 0.4s
      &:hover
        .overlay
          top 20%
    .texts
      display flex
      justify-content space-between
      align-items center
      padding-right 58px
      .cta
        a
          padding 0 1em
          text-transform none
          display flex

    @media mq-tablet-less
      width 60vw
      .texts
        padding-right 30px

</style>